import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
// import { ParallaxPlanet } from 'sections/Events/components/ParallaxPlanet';
import styles from 'sections/Events/FutureOfFreight/components/SectionArticles/SectionArticles.module.scss';

const cn = classNames.bind(styles);

const SectionArticles = (): ReactElement => {
  return (
    <section className={cn('articles')}>
      <div className={cn('container')}>
        <div className={cn('articles__content')}>
          <div className={cn('articles__description')}>
            <p className={cn('articles__description-title')}>description</p>
            <div className={cn('articles__description-content')}>
              <p className={cn('articles__description-text')}>
                The Digital Freight Alliance Conference on Digitalization and the Future of Freight will be held in
                Bangkok, Thailand, on 19 July. DFA is proud to host this event with our co-organizer TIFFA, the Thai
                International Freight Forwarder Association.
              </p>
              <p className={cn('articles__description-text')}>
                The event is the DFA's first in ASEAN and is open to members of TIFFA, DFA, and new members who wish
                to join.
              </p>
              <p className={cn('articles__description-text')}>
                The event will feature speakers and perspectives on how SME forwarders are extending their businesses
                digitally through web integrations for track and trace, ship schedules, rate management and a
                comprehensive ERP system.
              </p>
              <p className={cn('articles__description-text')}>
                This conference presents a fantastic opportunity to learn how SMEs can leverage digital tools to build
                resilient supply chains and to network with industry peers.
              </p>
            </div>
          </div>

          {/* <ParallaxPlanet /> */}

          <div className={cn('articles__page-image-box')}>
            <img
              className={cn('articles__page-image')}
              src="/images/pages/Events/FutureOfFreight/meeting.png"
              alt="future-of-freight"
            />
          </div>

          <div className={cn('articles__hotel')}>
            <p className={cn('articles__hotel-description')}>
              Regarding accommodation, we are pleased to offer 20% discount for Stay for Breakfast rate so you can use
              cluster code <span className={cn('articles__text--bold')}>K6Y</span> to get the special rate as per screen shot
              below.
            </p>
            <div className={cn('articles__hotel-image-box')}/>
            <div className={cn('articles__hotel-links-box')}>
              <Link
                rel="nofollow"
                className={cn('articles__button-go-to')}
                href="https://www.marriott.com/en-us/hotels/bkkqp-bangkok-marriott-marquis-queens-park/overview/"
              >
                Go to Hotel website
                <svg viewBox="0 0 10 10" aria-hidden="true">
                  <path d="M1 5h7" />
                  <path d="M2 1l4 4-4 4" />
                </svg>
              </Link>
            </div>
          </div>

          <div className={cn('articles__content-icons-box')}>
            <ul className={cn('articles__content-icons')}>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-planet.svg" alt="icon" className={cn('articles__content-image')}/>
                <p className={cn('articles__content-text')}>Networking</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-diamond.svg" alt="icon" className={cn('articles__content-image')} />
                <p className={cn('articles__content-text')}>First-class organization</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-comment-cloud.svg" alt="icon" className={cn('articles__content-image')} />
                <p className={cn('articles__content-text')}>SME</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-profile.svg" alt="icon" className={cn('articles__content-image')} />
                <p className={cn('articles__content-text')}>Industry speakers</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-suitcase.svg" alt="icon" className={cn('articles__content-image')} />
                <p className={cn('articles__content-text')}>Experts</p>
              </li>
              <li className={cn('articles__content-icon')}>
                <img src="/images/pages/Events/icon-ellipsis.svg" alt="icon" className={cn('articles__content-image')} />
                <p className={cn('articles__content-text')}>Much more</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>  
  );
};

export default SectionArticles;